import { connect } from 'react-redux';
import { createUser } from 'data/login/login.actions';
import CreateOrLoginContainer from './CreateOrLoginContainer';

const actions = {
  createUser
};

function mapStateToProps(state) {
  return {
    ...state.login
  };
}

export default connect(mapStateToProps, actions)(CreateOrLoginContainer);
